import React from 'react';
import { Airplay } from 'lucide-react';
import { useAirPlay } from '../utils/airplay';

// Renders the Safari AirPlay picker button. Auto-hides on any browser that
// doesn't expose AirPlay's private WebKit API — safe to drop in anywhere.
//
// Props:
//   videoRef    — React ref pointing at the <video> element to hand off
//   size        — icon px (default 20)
//   className   — wrapper classes for the outer button
//   activeClass — extra classes to apply when playback is currently on a
//                 remote AirPlay device (fuchsia glow by default so users
//                 have an obvious "you are casting" cue)
//   videoKey    — pass currentVideo?.id (or similar) so the hook re-attaches
//                 its listeners when a new video swaps in
//   'data-testid' — override default for QA
export const AirPlayButton = ({
  videoRef,
  size = 20,
  className = '',
  activeClass = 'text-fuchsia-300',
  videoKey,
  'data-testid': testId = 'airplay-button',
}) => {
  const { available, wireless, show } = useAirPlay(videoRef, videoKey);

  // Not on Safari OR no receivers found yet → render nothing. This is
  // intentional: showing a dead button on Chrome/Android would just
  // confuse users into thinking casting is broken.
  if (!available) return null;

  return (
    <button
      type="button"
      onClick={(e) => { e.stopPropagation(); show(); }}
      title={wireless ? 'AirPlay (connected)' : 'AirPlay'}
      aria-label={wireless ? 'Stop AirPlay' : 'Start AirPlay'}
      data-testid={testId}
      className={
        'inline-flex items-center justify-center rounded-full text-white/90 ' +
        'hover:text-white hover:bg-white/20 transition-colors w-10 h-10 ' +
        (wireless ? activeClass : '') + ' ' + className
      }
    >
      <Airplay size={size} />
    </button>
  );
};
